import { Visit, VisitTask } from '../../../../tmc-visit.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-visit-tasks',
    templateUrl: './visit-tasks.component.html',
    styleUrls: ['./visit-tasks.component.scss'],
    standalone: false
})
export class VisitTasksComponent {
  visit: Visit;
  tasks = new Array<VisitTask>();

  @Input('visit') set setVisit(visit: Visit) {
    this.visit = visit;
    this.tasks = new Array<VisitTask>();
  }

  @Input() upfrontRegistration: boolean;

  @Output() openMandatoryTasksChanged = new EventEmitter<boolean>();

  confirmTask(task: VisitTask) {
    console.log('this.upfrontRegistration', this.upfrontRegistration);
    task.done = true;
    var openMandatoryTasks = false;
    if (!this.upfrontRegistration) {
      for (const task of this.visit.tasks) {
        if (!task.done && !task.optional && !task.doneBefore) {
          openMandatoryTasks = true;
        }
      }
    }
    this.openMandatoryTasksChanged.next(openMandatoryTasks);
  }
}
